jQuery(function () {
    var $table = jQuery('#facilities');
    var city_filter = null;

    if (jQuery('#api-end-point-url').length){
    var $api_end_point_url = jQuery('#api-end-point-url').val();
    }

    jQuery('body').on('change', "#search-city", function () {

      var $city = jQuery('#search-city');
        var get = {};

        jQuery('#load-more').show();
        jQuery('.table__column--no-results').remove();

        city_filter = $city.val();
        get.city = city_filter;
        jQuery('#search-postalcode').val('');

        get.offset = 0;

        jQuery.get($api_end_point_url, get, function (response) {
            var $html = jQuery(response);
            $table.children('tbody').remove();
            $table.append(response);
            var resultCount = $table.find("tbody tr.table__row").not(".table__row--hidden").length;
            if (resultCount === 1 ) {
                jQuery(".audible-results").html(resultCount + " location found in " + city_filter);
            }
            else {
                jQuery(".audible-results").html(resultCount + " locations found in " + city_filter);
            }

            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more').hide();
            }

        });

        jQuery("#view-all-city").removeClass("d-none");
        $city.children("option").first().prop('selected', false);

        window.dataLayer.push({
            'event': 'formFieldInteraction',
            'formName': $(document).attr('title'),
            'fieldName': 'search-city',
            'fieldInput': city_filter
        });

        return false;
    });


    jQuery('body').on('click', "#search-postal-link", function () {
        var $postal = jQuery('#search-postalcode');
        var get = {};
        get.offset = 0;

        jQuery('#load-more').show();
        jQuery('.table__column--no-results').remove();

        if ($postal.val()) {
            get.postal_code = $postal.val();
            jQuery('#search-city').val(jQuery('#search-city option:first').val());
        }

        jQuery.get($api_end_point_url, get, function (response) {

            $table.children('tbody').remove();
            $table.append(response);

            var $html = jQuery(response);

            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more').hide();
            }

        });


        return false;
    });


    // Load more data into table
    jQuery('body').on('click', "#load-more", function () {

        var get = {};
        var records = $table.find('.table__row--clickable').length;
        get.offset = records;

        var $postal = jQuery('#search-postalcode');

        if (city_filter !== null) {
            get.city = city_filter;
        }

        if ($postal.val())
            get.postal = $postal.val();

        jQuery.get($api_end_point_url, get, function (response) {

            var $html = jQuery(response);

            $table.append(response);
            if (response != null || response != "") {
                setFocusToSearchResults();
            }

            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more').hide();
            }
        });

        return false;
    });

    //View all data
    jQuery('body').on('click', "#view-all-city", function () {

        var $city = jQuery('#search-city');
        var get = {};

        jQuery('#load-more').show();
        jQuery('.table__column--no-results').remove();

        city_filter = $city.children("option").first().val();
        $city.children("option").first().prop('selected', true);
        get.city = city_filter;
        jQuery('#search-postalcode').val('');

        get.offset = 0;

        jQuery.get($api_end_point_url, get, function (response) {
            var $html = jQuery(response);
            $table.children('tbody').remove();
            $table.append(response);
            if (response != null || response != "") {
                setFocusToSearchResults();
            }

            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more').hide();
            }

        });

        jQuery("#view-all-city").addClass("d-none");

        return false;
    });

    function setFocusToSearchResults() {
        // setting focus back to results table since chrome browser is jumping focus to top of page
        jQuery(".table--complex").parent().attr("tabindex", "-1");
        setTimeout(function(){
            jQuery(".table--complex").parent().focus();
        }, 200);
                
        // adding timeout to remove tabindex after
        setTimeout(function(){
            jQuery(".table--complex").parent().removeAttr("tabindex");
        }, 800);
    }

});


